export const buildData = (arg) => {
  const {
    variantId,
    parameters,
    projectNumber,
    projectReference,
    fabrication_quote,
  } = arg;

  if (!parameters || !variantId) return null;

  const form = new FormData();
  form.append('variant_id', variantId);
  form.append('parameters[project_number]', projectNumber);
  form.append('parameters[project_reference]', projectReference);
  form.append('quantity', 1);

  // If the user comes from a quote from Viewmate, we need to tell
  // the backend what the fabrication quote is so we can take the file from it
  if (fabrication_quote) {
    form.append('fabrication_quote', fabrication_quote);
  }

  Object.keys(parameters).forEach((key) => {
    if (key === 'filename') {
      return;
    }

    if (parameters[key] !== null || parameters[key] !== undefined || parameters[key] !== '') {
      form.append(`parameters[${key}]`, parameters[key]);
    }
  });

  // Append file to each stencil
  const inputFile = document.getElementById('gerber-file');
  const file = inputFile ? inputFile.files[0] : null;

  if (file) form.append('parameters[filename]', file);

  return form;
};

export const buildForms = (args) => {
  if (!args) return [];

  const { stencils, stencilsParameters, project_number, project_reference} = args;
  if (!stencils || !stencils.length) return [];

  const { part_number, revision } = stencilsParameters;

  return stencils.map((stencil) => {
    let partNumber;
    const { stencil_side } = stencil.parameters;

    if (part_number.includes('-')) {
      const [number] = part_number.split('-');
      partNumber = `${number}-${stencil_side}`;
    } else {
      partNumber = `${part_number}-${stencil_side}`;
    }

    const parameters = {
      ...stencil.parameters,
      ...stencilsParameters,
      part_number: partNumber,
      revision,
    };

    return buildData({
      variantId: stencil.variant.id,
      parameters,
      projectNumber: project_number,
      projectReference: project_reference,
    });
  });
};